"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withMath = exports.insertMathInline = exports.insertEmptyMathBlock = exports.insertMathBlock = exports.removeMathInlineAtPath = exports.removeMathBlockAtPath = exports.updateMathBlockCaption = exports.insertParagraphNearActiveMathBlock = exports.getActiveMathInlineEntry = exports.getActiveMathBlockEntry = exports.isMathInline = exports.isMathBlock = void 0;
const slate_1 = require("slate");
const voidInsert_1 = require("./voidInsert");
const isMathBlock = (node) => slate_1.Element.isElement(node) && node.type === 'math';
exports.isMathBlock = isMathBlock;
const isMathInline = (node) => slate_1.Element.isElement(node) && node.type === 'math-inline';
exports.isMathInline = isMathInline;
const createParagraphElement = () => ({
    type: 'p',
    children: [{ text: '' }],
});
const createMathBlockElement = (thingId, caption) => {
    const element = {
        type: 'math',
        '@thing': thingId,
        children: [{ text: '' }],
    };
    const trimmed = caption?.trim();
    if (trimmed)
        element.caption = trimmed;
    return element;
};
const createMathInlineElement = (thingId) => ({
    type: 'math-inline',
    '@thing': thingId,
    children: [{ text: '' }],
});
const getActiveMathBlockEntry = (editor) => {
    const { selection } = editor;
    if (!selection)
        return null;
    const match = slate_1.Editor.above(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => (0, exports.isMathBlock)(node),
    });
    return match ?? null;
};
exports.getActiveMathBlockEntry = getActiveMathBlockEntry;
const getActiveMathInlineEntry = (editor) => {
    const { selection } = editor;
    if (!selection)
        return null;
    const [match] = slate_1.Editor.nodes(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => (0, exports.isMathInline)(node),
    });
    return match ?? null;
};
exports.getActiveMathInlineEntry = getActiveMathInlineEntry;
const insertParagraphNearActiveMathBlock = (editor, position = 'below') => {
    const entry = (0, exports.getActiveMathBlockEntry)(editor);
    if (!entry)
        return null;
    const [, path] = entry;
    const targetPath = position === 'above' ? path : slate_1.Path.next(path);
    slate_1.Transforms.insertNodes(editor, createParagraphElement(), { at: targetPath });
    slate_1.Transforms.select(editor, slate_1.Editor.start(editor, targetPath));
    return targetPath;
};
exports.insertParagraphNearActiveMathBlock = insertParagraphNearActiveMathBlock;
const updateMathBlockCaption = (editor, path, caption) => {
    if (!slate_1.Node.has(editor, path))
        return false;
    const node = slate_1.Node.get(editor, path);
    if (!(0, exports.isMathBlock)(node))
        return false;
    const trimmed = caption?.trim();
    if (trimmed)
        slate_1.Transforms.setNodes(editor, { caption: trimmed }, { at: path });
    else
        slate_1.Transforms.unsetNodes(editor, 'caption', { at: path });
    return true;
};
exports.updateMathBlockCaption = updateMathBlockCaption;
const removeMathBlockAtPath = (editor, path) => {
    if (!slate_1.Node.has(editor, path))
        return false;
    const node = slate_1.Node.get(editor, path);
    if (!(0, exports.isMathBlock)(node))
        return false;
    slate_1.Transforms.removeNodes(editor, { at: path });
    return true;
};
exports.removeMathBlockAtPath = removeMathBlockAtPath;
const removeMathInlineAtPath = (editor, path) => {
    if (!slate_1.Node.has(editor, path))
        return false;
    const node = slate_1.Node.get(editor, path);
    if (!(0, exports.isMathInline)(node))
        return false;
    slate_1.Transforms.removeNodes(editor, { at: path });
    return true;
};
exports.removeMathInlineAtPath = removeMathInlineAtPath;
const insertMathBlock = (editor, thingId, caption) => (0, voidInsert_1.insertVoidBlock)(editor, createMathBlockElement(thingId, caption));
exports.insertMathBlock = insertMathBlock;
const insertEmptyMathBlock = (mutxt) => {
    const id = mutxt.things.add({ '@type': 'math', val: '', lang: 'latex' });
    const inserted = (0, exports.insertMathBlock)(mutxt.editor, id);
    return inserted ? id : null;
};
exports.insertEmptyMathBlock = insertEmptyMathBlock;
const insertMathInline = (editor, thingId) => {
    const node = createMathInlineElement(thingId);
    slate_1.Transforms.insertNodes(editor, node);
    slate_1.Transforms.move(editor, { distance: 1, unit: 'offset' });
    return node;
};
exports.insertMathInline = insertMathInline;
const tryOpenInlineMathEdit = (editor) => {
    const hook = editor.onOpenInlineMathEdit;
    if (!hook)
        return false;
    const entry = (0, exports.getActiveMathInlineEntry)(editor);
    if (!entry)
        return false;
    hook(entry[0], entry[1]);
    return true;
};
const withMath = (editor) => {
    const { isVoid, isInline, insertBreak, insertSoftBreak, insertText } = editor;
    editor.isVoid = (element) => {
        const type = element.type;
        if (type === 'math' || type === 'math-inline')
            return true;
        return isVoid(element);
    };
    editor.isInline = (element) => {
        if (element.type === 'math-inline')
            return true;
        return isInline(element);
    };
    editor.insertBreak = () => {
        if (tryOpenInlineMathEdit(editor))
            return;
        if ((0, exports.insertParagraphNearActiveMathBlock)(editor, 'below'))
            return;
        insertBreak();
    };
    editor.insertSoftBreak = () => {
        if (tryOpenInlineMathEdit(editor))
            return;
        if ((0, exports.insertParagraphNearActiveMathBlock)(editor, 'above'))
            return;
        insertSoftBreak();
    };
    editor.insertText = (text) => {
        if (text === ' ' && tryOpenInlineMathEdit(editor))
            return;
        if (text && (0, exports.insertParagraphNearActiveMathBlock)(editor, 'below')) {
            insertText(text);
            return;
        }
        insertText(text);
    };
    return editor;
};
exports.withMath = withMath;
